import React from 'react';

export default ({handleGoBackClick}) => {
  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div className='go-back-to-list-header-button' onClick={handleGoBackClick}>Back</div>
      <header className='_width_450'>
        Inspection Record Application
      </header>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/New/Header.jsx